// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LockFilledSvg from "@fishx/icons-svg/es/asn/LockFilled";
import FishxIcon from '../components/FishxIcon';

var LockFilled = function LockFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LockFilledSvg
  }));
};

LockFilled.displayName = 'LockFilled';
export default React.forwardRef(LockFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LockFilled.js
// module id = 3059
// module chunks = 0